import React from 'react'
import { createGlobalStyle } from 'styled-components'
import Lato100 from "../../fonts/Lato/lato-v24-latin-100.woff2"
import Lato100Italic from "../../fonts/Lato/lato-v24-latin-100italic.woff2"
import Lato300 from "../../fonts/Lato/lato-v24-latin-300.woff2"
import Lato300Italic from "../../fonts/Lato/lato-v24-latin-300italic.woff2"
import LatoRegular from "../../fonts/Lato/lato-v24-latin-regular.woff2"
import LatoItalic from "../../fonts/Lato/lato-v24-latin-italic.woff2"
import Lato700 from "../../fonts/Lato/lato-v24-latin-700.woff2"
import Lato700Italic from "../../fonts/Lato/lato-v24-latin-700italic.woff2"
import Lato900 from "../../fonts/Lato/lato-v24-latin-900.woff2"
import Lato900Italic from "../../fonts/Lato/lato-v24-latin-900italic.woff2"
const GlobalStyle = createGlobalStyle`
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: normal;
  font-weight: 100;
  src: url(${Lato100}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-100italic - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: italic;
  font-weight: 100;
  src: url(${Lato100Italic}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-300 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';  
  font-style: normal;
  font-weight: 300;
  src: url(${Lato300}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-300italic - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */

  font-family: 'Lato';
  font-style: italic;
  font-weight: 300;
  src: url(${Lato300Italic}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-regular - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  src: url(${LatoRegular}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-italic - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: italic;
  font-weight: 400;
  src: url(${LatoItalic}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-700 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  src: url(${Lato700}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-700italic - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: italic;
  font-weight: 700;
  src: url(${Lato700Italic}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-900 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';
  font-style: normal; 
  font-weight: 900;
  src: url(${Lato900}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lato-900italic - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: 'Lato';  
  font-style: italic;
  font-weight: 900;
  src: url(${Lato900Italic}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
  html, body {
    margin: 0;
    padding: 0;
    font-family: 'Lato', sans-serif;
  }`
function GlobalStyles() {

  return (
    <>
      <GlobalStyle />
    </>
  )
}

export default GlobalStyles